export default {
  CUSTOMERLISTS(state) {
    return state.customerLists;
  },
  customers(state) {
    return state.customers;
  },
}
